export class CandidateConferencePageController {
    /*@ngInject*/
    constructor($timeout) {
        this.$timeout = $timeout;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.candidateId = this.$stateParams.c;
        this.jobId = this.$stateParams.j;
        this.jobMatchId = this.$stateParams.jm;
        this.scheduleId = this.$stateParams.sh;
        // this.participantType = this.$stateParams.t;
        this.participantType = "c";
        this.mode = this.$stateParams.mode;
        this.workflowStep = this.$stateParams.ws;
        this.$timeout(() => {
            this.isLoaded = true;
        }, 4000);
    }
}
CandidateConferencePageController.$inject = ['$timeout'];
// import * as TEMPLATE from './candidate-conference-page.html';
import * as TEMPLATE from 'raw-loader!./candidate-conference-page.html';
export const CandidateConferencePageComponent = {
    selector: 'candidateConferencePage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/candidateConference/candidate-conference-page.html',
        template: TEMPLATE.default,
        controller: CandidateConferencePageController
    }
};
//# sourceMappingURL=candidate-conference-page.component.js.map